import { simpleFetchWithHttp } from './customFetch';

export const starTimer = () =>
  simpleFetchWithHttp(
    '/new-members/timer/self/start',
    {
      method: 'PATCH',
    },
    process.env.REACT_APP_NEW_MEMBER_API,
  );
